import { Component, OnInit, Input } from '@angular/core';
import { SDTKService } from '../../sdtk.service';

@Component({
  selector: 'app-sdtk-financials',
  templateUrl: './sdtk-financials.component.html',
  styleUrls: ['./sdtk-financials.component.css']
})
export class SdtkFinancialsComponent implements OnInit {

  premium: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';

  vehicle_premiums_value: number = 0;

  gross_premium: number | string = 0;
  commission: number = 0;
  total_amount: number | string = 0;
  peliwica_fee: number = 0;
  broker_admin_fee: number = 0;
  total_prem_inc_ipt: number | string = 0;
  ipt: number | string = 0;
  breakdown_ipt: number = 0;
  loading_charges: number = 0;

  quote: any;
  coverLimitOptions: any[] = [];
  cover_limit_amount: number = 0;

  constructor(private sdtkService: SDTKService) { }

  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.applyFinancials();
    }

    if (this.coverLimitOptions.length > 0) {
      this.updateSelectedCoverLimit();
    }
  }

  ngOnInit(): void {
    this.getCoverLimits();
  }

  // -------------------------------
  // Cover limits
  // -------------------------------

  public getCoverLimits() {
    this.sdtkService.getSDTKRatingOptions()
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.coverLimitOptions = response.result.map(option => ({
              ...option,
              is_selected: false
            }));

            this.updateSelectedCoverLimit();

            if (this.quote?.sdtk_option_id) {
              this.getCoverLimitName(this.quote.sdtk_option_id);
            }
          }
        },
        (error) => {
          console.error('Error fetching cover limits:', error);
        }
      );
  }

  private updateSelectedCoverLimit() {
    if (this.quote && this.quote.sdtk_option_id && this.coverLimitOptions.length > 0) {
      this.coverLimitOptions.forEach(option => {
        option.is_selected = (option.id === this.quote.sdtk_option_id);
      });
    }
  }

  getCoverLimitName(optionId: number): number {
    const option = this.coverLimitOptions.find(opt => opt.id === optionId);

    if (option && option.name) {
      this.cover_limit_amount = parseFloat(option.name.replace(/[£,]/g, ''));
      this.applyFinancials();
    }

    return this.cover_limit_amount;
  }

  // -------------------------------
  // Financial logic
  // -------------------------------

  private applyFinancials() {

    if (!this.quote || !this.quote.financial_details) {
      return;
    }

    // If cover limit > 10000 → TBC
    if (this.cover_limit_amount && this.cover_limit_amount > 10000) {

      this.ipt = 'TBC';
      this.gross_premium = 'TBC';
      this.total_prem_inc_ipt = 'TBC';
      this.total_amount = 'TBC';

    } else {

      this.ipt = this.quote.financial_details.ipt_value;

      this.gross_premium = Number(this.quote.financial_details.breakdown_gross);

      this.total_prem_inc_ipt =
        Number(this.quote.financial_details.breakdown_gross) +
        Number(this.quote.financial_details.ipt_value);

      this.total_amount = this.total_prem_inc_ipt;
    }
  }
  // -------------------------------
  // Safe display formatter
  // -------------------------------

  displayValue(value: number | string): string {

    if (value === 'TBC') {
      return 'TBC';
    }

    if (value === null || value === undefined || isNaN(Number(value))) {
      return '0.00';
    }

    return Number(value).toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}
